export const TOKEN = "jwt";
export const DOMAIN_AIRPAYONE = "https://api.airpayone.com/";
